import classNames from "classnames";
import React from "react";

import "./_animated-background.scss";

interface IAnimatedBackgroundProps extends React.PropsWithoutRef<JSX.IntrinsicElements["div"]> {}

export const AnimatedBackground: React.FC<IAnimatedBackgroundProps> = ({ className, children, ...rest }) => {
  const classes = classNames("animated-background", className);

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};
